module.exports = __webpack_public_path__ + "img/MELA_Plasma.4dba8990.png";